var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningBoltYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 42,
    viewBox: "0 0 32 42",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.4515 17.1696c.6814-.8509.0986-2.1409-.9671-2.1409h-12.5141c-.8975 0-1.5061-.9481-1.1609-1.8083l4.5763-11.40193c.5553-1.383499-1.2052-2.48984-2.1281-1.33732l-18.964591 23.68475c-.681308.8509-.098572 2.1409.967101 2.1409h12.51409c.8975 0 1.5062.9481 1.1609 1.8084l-4.5762 11.4018c-.55531 1.3835 1.2052 2.4899 2.128 1.3374z",
    fill: "#ffd83b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningBoltYellow);
export default __webpack_public_path__ + "static/media/lightning-bolt-yellow.a1943fd6c5339abeb422537c96729387.svg";
export { ForwardRef as ReactComponent };